/**
 * Checkbox Interface
 * Boolean toggle/checkbox with customizable label
 * Matching reference implementation pattern
 */

import { Checkbox as ShadCheckbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface CheckboxInterfaceProps {
    value: boolean | null;
    onChange: (value: boolean) => void;
    disabled?: boolean;
    label?: string;
    className?: string;
}

export function CheckboxInterface({
    value,
    onChange,
    disabled = false,
    label = 'Enabled',
    className,
}: CheckboxInterfaceProps) {
    return (
        <div className={cn('flex items-center space-x-2', className)}>
            <ShadCheckbox
                id="checkbox-field"
                checked={value === true}
                onCheckedChange={(checked) => onChange(checked === true)}
                disabled={disabled}
            />
            <Label
                htmlFor="checkbox-field"
                className={cn(
                    'text-sm cursor-pointer font-normal',
                    disabled && 'opacity-50 cursor-not-allowed'
                )}
            >
                {label}
            </Label>
        </div>
    );
}
